import store from '@/store'
import router from '@/router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'

const config = {
  apiKey: 'AIzaSyDyeD1Tkg2PyY5Nq3Z84GT9FMGizqFMKXw',
  authDomain: 'oracle-services-vzla.firebaseapp.com',
  databaseURL: 'https://oracle-services-vzla.firebaseio.com',
  projectId: 'oracle-services-vzla',
  storageBucket: 'oracle-services-vzla.appspot.com',
  messagingSenderId: '1071850495527',
  appId: '1:1071850495527:web:149c8892beb9d9810f7802',
}

/* const config = {
  apiKey: "AIzaSyAMyfwKnQVrDuDipz4QDY2i8qzSrX9huVw",
  authDomain: "politicas-col.firebaseapp.com",
  projectId: "politicas-col",
  storageBucket: "politicas-col.appspot.com",
  messagingSenderId: "963364882064",
  appId: "1:963364882064:web:4498d483a33c0b12c07a15"
} */

export default {
  install: (Vue, options) => {
    const firebaseApp = firebase.initializeApp(config)
    const auth = firebaseApp.auth()

    Vue.prototype.$storage = firebaseApp.storage()
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        return auth.signInWithEmailAndPassword(username, pass)
      },
      logout: async () => {
        router.push('/system/login')
        await auth.signOut()
      },
    }
    auth.onAuthStateChanged(user => {
      store.commit('UPDATE_USER', { user })
    })
  },
}
